import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectStoreCount, selectLoginUrl } from 'core/selectors/app';
import { triggerHomeValueBannerViewed } from './actions';

import './HomeValueBanner.scss';

function HomeValueBanner({ children, handleClick }) {
  const storeCount = useSelector(selectStoreCount);
  const loginUrl = useSelector(selectLoginUrl);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(triggerHomeValueBannerViewed());
  }, [dispatch]);

  const clickHandler = () => {
    dispatch(handleClick());
  };

  return (
    <div className="mn_homeValueBanner" role="button" tabIndex={0} onClick={clickHandler}>
      {children}
      <div className="mn_contentWrap">
        <div className="mn_bannerText">
          <h2>Shop today, fly later</h2>
          <p>As a MileagePlus member, earn miles towards your next trip
            by shopping at {storeCount}+ stores online and in-store.
          </p>
          <a className="mn_button" href={loginUrl}>Sign in</a>
        </div>
      </div>
    </div>
  );
}

export default HomeValueBanner;
